var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-card",
    { staticClass: "centered card" },
    [
      _c(
        "sui-card-content",
        [
          _c(
            "div",
            {
              staticClass: "center aligned header",
              staticStyle: { margin: "1.5em" },
            },
            [_vm._v("Log in")]
          ),
          _c(
            "sui-form",
            { staticClass: "login-form" },
            [
              _vm.authenticationFailed
                ? _c("Message", { attrs: { messageContent: _vm.message } })
                : _vm._e(),
              _c(
                "sui-form-field",
                [
                  _c("label", [_vm._v("Email address")]),
                  _c("sui-input", {
                    attrs: {
                      type: "email",
                      icon: "user",
                      "icon-position": "left",
                      placeholder: "Email address",
                      autocomplete: "false",
                    },
                    model: {
                      value: _vm.userCredentials.email,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userCredentials,
                          "email",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "userCredentials.email",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "error-message", attrs: { hidden: "" } },
                    [_vm._v("Please enter your email address.")]
                  ),
                ],
                1
              ),
              _c(
                "sui-form-field",
                [
                  _c(
                    "div",
                    { staticClass: "password-label" },
                    [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("Password"),
                      ]),
                      _c("font-awesome-icon", {
                        staticClass: "label-icon",
                        attrs: { icon: _vm.passwordLabelIcon },
                        on: { click: _vm.togglePasswordInputType },
                      }),
                    ],
                    1
                  ),
                  _c("sui-input", {
                    attrs: {
                      type: _vm.passwordInputType,
                      icon: "lock",
                      "icon-position": "left",
                      placeholder: "Password",
                      autocomplete: "false",
                    },
                    model: {
                      value: _vm.userCredentials.password,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.userCredentials,
                          "password",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "userCredentials.password",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "error-message", attrs: { hidden: "" } },
                    [_vm._v("Please enter your password.")]
                  ),
                ],
                1
              ),
              _c(
                "sui-grid",
                [
                  _c(
                    "sui-grid-row",
                    [
                      _c(
                        "sui-grid-column",
                        [
                          _c("sui-button", {
                            staticClass: "login-button",
                            attrs: {
                              content: "Log In",
                              type: "button",
                              fluid: "",
                              color: "teal",
                            },
                            on: { click: _vm.login },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-row",
                    [
                      _c("sui-grid-column", [
                        _c(
                          "div",
                          { staticClass: "forgotten-password" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "router-link",
                                attrs: { to: { name: "forgotPassword" } },
                              },
                              [_vm._v(" Forgot your password? ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }